import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ListTNCN.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  ExpandSearch,
  ListActionButton,
} from "../../../../../components/common";
import { Button, Col, Row, Space, Table, Typography } from "antd";
import { ExcelSVG, PlusWhiteSVG } from "../../../../../assets";
import { searchTNCN } from "../../../../../redux/reducer/employee";
import { employeeService } from "api";
import ModalCustom from "../../../../../components/common/ModalCustom/ModalCustom";
import FormAdd from "./FormAdd/FormAdd";
import Notification from "../../../../../components/common/notification/notification";
import axiosClient from "../../../../../api/_";
import { generateFileName, saveTableOptions,getTableOptions } from "../../../../../helper/common";
import Icons from 'assets/icons';
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { setButtonsHeader } from "redux/reducer/common";
const ListTNCN = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = currentDate.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const modalRef = useRef<any>();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 1000,
    nam: currentYear,
    thang: currentMonth,
  });
  const [loading, setLoading] = useState(false);
  //   const [columns, setColumns] = useState<any>(
  //     allColumns.filter((e) => e.show == true)
  //   );
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const onClickSearch = async () => {
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  // useEffect(() => {
  //   expandRef?.current.setFieldValue("nam", currentYear);
  //   expandRef?.current.setFieldValue("thang", currentMonth);
  // }, []);
  const getList = async () => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchTNCN(params));
    setLoading(false);
  };
  useEffect(() =>{
    dispatch(setButtonsHeader([]));
  },[])
  //   const handleSave = (row: any) => {
  //     const newData = [...data];
  //     const index = newData.findIndex((item) => row.id === item.id);
  //     const item = newData[index];
  //     newData.splice(index, 1, {
  //       ...item,
  //       ...row,
  //     });
  //     setData(newData);
  //   };
  useEffect(() => {
    getList();
  }, [params]);
  // useEffect(() => {
  //     getList({
  //         ...paramss,
  //     });
  // }, [paramss]);
  useEffect(() => {
    setData(
      employees.TNCNList.map((list) => ({
        ...list,
        key: list.id,
      }))
    );
  }, [employees.TNCNList]);

  // const rowSelection = {
  //     onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
  //         const record = selectedRows[0];

  //         dispatch();

  //     },
  // };
  //   const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
  //     setColumns(showColumns);
  //   };

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel(params);
  };
  //   useEffect(() => {
  //     setColumns(
  //       allColumns
  //         .map((col) => {
  //           if (!col.editable) {
  //             if (col.dataIndex === "index") {
  //               return {
  //                 title: "STT",
  //                 key: "index",
  //                 show: true,
  //                 dataIndex: "index",
  //                 render(_, __, index) {
  //                   return <>{index + 1 + (params.page - 1) * params.limit}</>;
  //                 },
  //                 fixed: "left",
  //                 width: 50,
  //                 align: "center",
  //               };
  //             } else {
  //               return col;
  //             }
  //           }
  //           return {
  //             ...col,
  //             onCell: (record: any) => ({
  //               record,
  //               editable: true,
  //               dataIndex: col.dataIndex,
  //               title: col.title,
  //               handleSave,
  //             }),
  //           };
  //         })
  //         .filter((e) => e.show == true)
  //     );
  //   }, [data]);
  const handleExportExcel = async (params) => {
    const url = "hanhchinhnhansu/bieu-thue-tncn-phai-nop/export-excel";

    const baseName = "danh-sach-bieu-thue";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const deleteRecruitment = async (id) => {
    try {
      const res = await employeeService.deleteTNCN(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");
      getList();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };
  useEffect(() => {
    const newColumns = allColumns;
    allColumns.find((e) => e.dataIndex == "action").render = (
      value,
      _record,
      index
    ) => {
      return (
        <ListActionButton
          deleteFunction={() => {
            deleteRecruitment(_record.id);
          }}
          editFunction={() => {
            setType("Sửa");
            setRecord(_record);

            modalRef.current?.openModal();
          }}
        ></ListActionButton>
      );
    };

    // setColumns(newColumns);
  }, []);
  let savedTableOption = getTableOptions(
    "LISTTNCN_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.find((e)=> e.dataIndex === "index").render=(text,record,index) =>{
    const rowNumber =(currentPage - 1) * params.limit + index + 1;
    return rowNumber;
  }
  const setShowColumnsList = showColumns => {
    saveTableOptions(
      "LISTTNCN_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  return (
    <div className="recruitment-list" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="recruitment-container">
        <div className="container">
          <ExpandSearch
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container">
          <Space style={{ width: "100%" }} direction="vertical">
            <Row justify={"end"} gutter={[16, 8]}>
              <Col>
                <Button
                  className="custom-btn"
                  type="default"
                  onClick={onClickExport}
                  icon={<ExcelSVG />}
                >
                  <Typography>Xuất báo cáo</Typography>
                </Button>
              </Col>
              <Button
                type="primary"
                // className="btn-sub"
                // icon={<Icons.add rev={0} />}
                onClick={() => {
                  setType("Thêm");
                  setRecord(null);
                  modalRef.current?.openModal();
                }}
              >
                Thêm mới
              </Button>
            </Row>
            {data && (
              <CustomResizableTable
              setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.TNCNTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                rowKey={(record) => record.id}
                columns={defaultColumns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: scrollX }}
              />
            )}
            <ModalCustom
              ref={modalRef}
              width={1200}
              title={`${type} mới biểu thuế`}
              centered
            >
              <FormAdd
                data={record}
                getListApi={getList}
                type={type}
                setCurrentPage={null}
              ></FormAdd>
            </ModalCustom>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListTNCN;
